import Core from './src/index'

const install = (Vue, { router } = {}) => {
  if (install.installed) {
    return
  }

  install.installed = true
  Vue.util.defineReactive(Vue.prototype, '$bus', new Vue()) // 设置eventBus

  Vue.use(Core, {
    router
  })

  window.rrc = Object.create(null)
  window.rrc.$loading = () => {
    const loading = Vue.prototype.$toast.loading({
      duration: 0, // 持续展示 toast
      message: '加载中...',
      forbidClick: true,
    })
    loading.close = () => {
      loading.clear()
    }
    return loading
  }
}

export default {
  install
}
